import React, { useState, useEffect } from "react";

import cube from "services/cube";
import { Form, Loading } from "components";

export function Campaigns({ onChange, value, placeholder = "Todas" }) {
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    cube
      .get("/list/campaigns")
      .then((response) => setCampaigns(response.data))
      .catch((error) => console.error(error));
  }, []);

  if (!campaigns.length) {
    return <Loading />;
  }

  return (
    <Form.Select
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={campaigns.map((campaign) => ({
        value: campaign.id,
        label: campaign.title,
      }))}
    />
  );
}
